/**
 * The Google Maps embed for an event's venue: pinned to the exact place when
 * the event has one and an embed key is configured, otherwise a search for
 * the venue name. Empty when the event has no location yet.
 */
export const sparkMapEmbedUrl = (spark: {
  location?: string | null;
  google_maps_place_id?: string | null;
}) => {
  if (!spark.location) return "";
  const apiKey = import.meta.env.VITE_GOOGLE_MAPS_EMBED_API_KEY;
  if (apiKey && spark.google_maps_place_id) {
    return `https://www.google.com/maps/embed/v1/place?key=${apiKey}&q=place_id:${spark.google_maps_place_id}&zoom=13`;
  }
  return `https://www.google.com/maps?q=${encodeURIComponent(spark.location)}&output=embed`;
};
